import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Tooltip,
  Chip,
  IconButton,
} from "@mui/material";
import { ArrowForwardIosRounded } from "@mui/icons-material";
import { getFileIconImage } from "../../../../../../../utils/fileUtils";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  icon: {
    fontSize: "7px !important",
  },
  card: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
  },
  activeCard: {
    border: `1px solid ${
      theme.palette.mode === "dark"
        ? theme.palette.primary.main
        : theme.palette.accent
    }`,
    background: theme.palette.paper,
  },
}));

function FileBlock({
  block,
  selectedFileFromStream,
  onSelectedFileFromStreamChange,
}) {
  const { classes } = useStyles();
  const { attributes, content } = block;
  const fileType = attributes?.url?.split(".").pop();
  const entityExists = attributes?.url;
  const isSelected = selectedFileFromStream?.url === attributes?.url;
  return (
    <Box mb={2}>
      <Tooltip title={"Open attachment"}>
        <Box
          display={"inline-block"}
          sx={{
            cursor: "pointer",
            "& .file-name": {
              textDecoration: "underline",
              textDecorationColor: isSelected ? "#1976d2" : "currentColor",
              transition: "text-decoration-color 0.2s",
            },
            "&:hover .file-name": {
              textDecorationColor: "#1976d2",
            },
          }}
          onClick={() => onSelectedFileFromStreamChange(attributes)}>
          <Box display={"flex"} alignItems={"center"} gap={1}>
            <img
              src={getFileIconImage(fileType)}
              alt={attributes?.name}
              width={20}
              height={20}
            />
            <Typography
              className="file-name"
              noWrap
              textOverflow={"ellipsis"}
              overflow={"hidden"}>
              {attributes?.name}
            </Typography>
          </Box>
          {/* <Card
        elevation={1}
        onClick={() => onSelectedFileFromStreamChange(attributes)}
        className={`${classes.card} ${isSelected ? classes.activeCard : null}`}>
        <CardActionArea sx={{ pointerEvents: entityExists ? "auto" : "none" }}>
          <CardContent
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <Box
              display={"flex"}
              alignItems={"center"}
              mr={1.5}
              width={"calc(100% - 36px)"}>
              <img
                src={getFileIconImage(fileType)}
                alt={attributes?.name}
                width={24}
                height={24}
                style={{ marginRight: 12 }}
              />

              <Box width={"calc(100% - 40px)"}>
                <Typography fontWeight={500} variant="body2">
                  {content}
                </Typography>
                <Box mb={1.5} />
                <Tooltip title={attributes?.name}>
                  <Chip
                    label={
                      <Typography variant="caption" noWrap>
                        {attributes?.name}
                      </Typography>
                    }
                    size="small"
                    icon={
                      <img
                        src={getFileIconImage(fileType)}
                        alt={attributes?.name}
                        width={16}
                        height={16}
                      />
                    }
                  />
                </Tooltip>
              </Box>
            </Box>
            <IconButton size="small">
              <ArrowForwardIosRounded fontSize="small" />
            </IconButton>
          </CardContent>
        </CardActionArea>
      </Card> */}
        </Box>
      </Tooltip>
    </Box>
  );
}

export default FileBlock;
